"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.unfollow = exports.follow = exports.getFollowingUsers = exports.getMyFollowers = void 0;
var axios_1 = __importDefault(require("axios"));
var getMyFollowers = function (_a) {
    var userId = _a.userId;
    return axios_1.default.get("".concat(process.env.REACT_APP_BACKEND_DOMAIN, "/api/v2/relations/followers/").concat(userId), {
        params: {
            enrich: true
        }
    });
};
exports.getMyFollowers = getMyFollowers;
var getFollowingUsers = function (_a) {
    var userId = _a.userId;
    return axios_1.default.get("".concat(process.env.REACT_APP_BACKEND_DOMAIN, "/api/v2/relations/following/").concat(userId), {
        params: {
            enrich: true
        }
    });
};
exports.getFollowingUsers = getFollowingUsers;
var follow = function (payload) {
    return axios_1.default.post("".concat(process.env.REACT_APP_BACKEND_DOMAIN, "/api/v2/relations/follow"), { userId: payload.userId, targetId: payload.targetId, token: payload.token });
};
exports.follow = follow;
var unfollow = function (payload) {
    return axios_1.default.post("".concat(process.env.REACT_APP_BACKEND_DOMAIN, "/api/v2/relations/unfollow"), { userId: payload.userId, targetId: payload.targetId, token: payload.token });
};
exports.unfollow = unfollow;
